import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import Chatbot from '../chatbot'
import { SideBar } from '../common/sideBar'
import {
  selectComponentAuthorized,
  selectUserType,
} from '../layout/store/slice'
import { COMPONENTS } from '../routers/constants'
import { USER_TYPE } from '../utils/authorization'
import { ValidateOrgId } from './ValidateOrgId'
import { getIsLock } from './helper'
import './lang/i18n'

const getListData = (userType, AUTHORIZATION) => [
  {
    ...COMPONENTS.companyAnalysis.components.summary,
    label: 'companyAnalysis.SUMMARY',
    keepQueryStrParams: ['organizationId'],
    isLock: getIsLock(userType, AUTHORIZATION.companyAnalysis.summary),
  },
  {
    ...COMPONENTS.companyAnalysis.components.companyProfile,
    label: 'companyAnalysis.COMPANY_PROFILE',
    keepQueryStrParams: ['organizationId'],
    isLock: getIsLock(userType, AUTHORIZATION.companyAnalysis.companyProfile),
  },
  {
    ...COMPONENTS.companyAnalysis.components.ownershipAndGroup,
    label: 'companyAnalysis.OWNERSHIP_AND_GROUP',
    keepQueryStrParams: ['organizationId'],
    isLock: getIsLock(
      userType,
      AUTHORIZATION.companyAnalysis.ownershipAndGroup,
    ),
  },
  {
    ...COMPONENTS.companyAnalysis.components.filingStatus,
    label: 'companyAnalysis.FILING_STATUS',
    keepQueryStrParams: ['organizationId'],
    isLock: getIsLock(userType, AUTHORIZATION.companyAnalysis.filingStatus),
  },
  {
    ...COMPONENTS.companyAnalysis.components.newsAndSocials,
    label: 'companyAnalysis.NEWS_AND_SOCIALS',
    keepQueryStrParams: ['organizationId'],
    isLock: getIsLock(userType, AUTHORIZATION.companyAnalysis.newsAndSocials),
  },
  {
    label: 'companyAnalysis.FINANCIAL',
    children: [
      {
        ...COMPONENTS.companyAnalysis.components.financial.components
          .financialStatements,
        label: 'companyAnalysis.FINANCIAL_STATEMENTS',
        keepQueryStrParams: ['organizationId'],
        isLock: getIsLock(
          userType,
          AUTHORIZATION.companyAnalysis.financial.financialStatements,
        ),
      },
      {
        ...COMPONENTS.companyAnalysis.components.financial.components
          .financialAnalysis,
        label: 'companyAnalysis.FINANCIAL_ANALYSIS',
        keepQueryStrParams: ['organizationId'],
        isLock: getIsLock(
          userType,
          AUTHORIZATION.companyAnalysis.financial.financialAnalysis,
        ),
      },
    ],
  },
  // SCORE
  ...(userType?.userTypeId === USER_TYPE.STANDARD
    ? [
        {
          ...COMPONENTS.companyAnalysis.components.score.components.standard,
          label: 'companyAnalysis.SCORE',
          keepQueryStrParams: ['organizationId'],
          isLock: getIsLock(userType, AUTHORIZATION.companyAnalysis.score),
        },
      ]
    : [
        {
          label: 'companyAnalysis.SCORE',
          children: [
            {
              ...COMPONENTS.companyAnalysis.components.score.components
                .corporateRiskScore,
              label: 'companyAnalysis.CORPORATE_RISK_SCORE',
              keepQueryStrParams: ['organizationId'],
              isLock: getIsLock(userType, AUTHORIZATION.companyAnalysis.score),
            },
            {
              ...COMPONENTS.companyAnalysis.components.score.components
                .corporatePerformanceScore,
              label: 'companyAnalysis.CORPORATE_PERFORMANCE_SCORE',
              keepQueryStrParams: ['organizationId'],
              isLock: getIsLock(userType, AUTHORIZATION.companyAnalysis.score),
            },
          ],
        },
      ]),
  {
    ...COMPONENTS.companyAnalysis.components.peerAnalysis,
    label: 'companyAnalysis.PEER_ANALYSIS',
    keepQueryStrParams: ['organizationId'],
    isLock: getIsLock(userType, AUTHORIZATION.companyAnalysis.peerAnalysis),
  },
  {
    label: 'companyAnalysis.INDUSTRY',
    children: [
      {
        ...COMPONENTS.companyAnalysis.components.industry.components
          .industryOverview,
        label: 'companyAnalysis.INDUSTRY_OVERVIEW',
        keepQueryStrParams: ['organizationId'],
        isLock: getIsLock(
          userType,
          AUTHORIZATION.companyAnalysis.industry.industryOverview,
        ),
      },
      {
        ...COMPONENTS.companyAnalysis.components.industry.components
          .industryAnalysis,
        label: 'companyAnalysis.INDUSTRY_ANALYSIS',
        keepQueryStrParams: ['organizationId'],
        isLock: getIsLock(
          userType,
          AUTHORIZATION.companyAnalysis.industry.industryAnalysis,
        ),
      },
    ],
  },
]

export const Layout = ({
  renderTopComponent,
  renderBottomComponent,
  renderStickyComponent,
  renderFooter,
  isShowSideBarWhenResponsive,
  isShowFooter,
  isLoadingContent,
  disableValidateOrgId,
}) => {
  const userType = useSelector(selectUserType)
  const AUTHORIZATION = useSelector(selectComponentAuthorized)
  const renderSideBar = () => {
    return (
      <SideBar
        list={getListData(userType, AUTHORIZATION)}
        renderTopComponent={renderTopComponent}
        renderStickyComponent={renderStickyComponent}
        renderBottomComponent={renderBottomComponent}
        renderFooter={renderFooter}
        isShowSideBarWhenResponsive={isShowSideBarWhenResponsive}
        isShowFooter={isShowFooter}
        scrollId="companyAnalysis"
        isLoadingContent={isLoadingContent}
      />
    )
  }

  if (disableValidateOrgId) {
    return renderSideBar()
  }
  return (
    <ValidateOrgId>
      {renderSideBar()}
      <Chatbot />
    </ValidateOrgId>
  )
}

Layout.propTypes = {
  renderTopComponent: PropTypes.func,
  renderBottomComponent: PropTypes.func,
  renderStickyComponent: PropTypes.func,
  renderFooter: PropTypes.func,
  isShowFooter: PropTypes.bool,
  isLoadingContent: PropTypes.bool,
  disableValidateOrgId: PropTypes.bool,
}

Layout.defaultProps = {
  renderTopComponent: () => {},
  renderBottomComponent: () => {},
  renderStickyComponent: () => {},
  renderFooter: () => {},
  isShowFooter: true,
  isLoadingContent: false,
  disableValidateOrgId: false,
}
